import GradientLoadingIndicator from './GradientLoadingIndicator';

export default GradientLoadingIndicator;
